module.exports = __webpack_public_path__ + "static/img/theme_4.82e65ac2.png";